export interface ScreenInterface {
  size: number;
  container: number;
}

export interface ScreensInterface {
  phone: ScreenInterface;
  tablet: ScreenInterface;
  medium: ScreenInterface;
  desktop: ScreenInterface;
  [key: string]: any;
}

export interface ConstantsInterface {
  columns: number;
  columnGap: number;
  screens: ScreensInterface;
}

const constants: ConstantsInterface = {
  columns: 12,
  columnGap: 24,
  screens: {
    phone: {
      size: 576,
      container: 540,
    },
    tablet: {
      size: 768,
      container: 720,
    },
    medium: {
      size: 992,
      container: 960,
    },
    desktop: {
      size: 1200,
      container: 1140,
    },
  },
};

export default constants;
